import React from 'react';

const ContainerLayout = props => {
  return <div className="app-container">{props.children}</div>;
};

export default ContainerLayout;
